module.exports = __webpack_public_path__ + "static/img/5.4e3ebc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/5.png
// module id = VydD
// module chunks = 0